





























import {Vue, Component} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';
import {ReviewDisplayStatusType} from 'supporter';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';
@Component({
  components: {
    RadioElement
  }
})
export default class ChangeDisplayStatus extends Vue {
  private reviewNos: any = [];

  // 전시상태
  private reviewDisplayStatusType = 'DISPLAY';
  private displayStatusType = {
    name: 'displayStatusType',
    data: [
      {
        id: 'displayStatusType_DISPLAY',
        value: 'DISPLAY',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY'
      },
      {
        id: 'displayStatusType_BLIND',
        value: 'BLIND',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND'
      }
    ]
  };

  // 확인
  private async confirm() {
    let request = {
      data: {
        reviewNos: this.reviewNos,
        displayStatusType: this.reviewDisplayStatusType as ReviewDisplayStatusType
      }
    };
    let {data} = await this.$api.putReviewsStatus(request);
    let callBack = sessionStorage.getItem('callBack');
    if (callBack) {
      $(window.opener.location).attr('href', `javascript:window.${callBack}(${JSON.stringify(data)});`);
    }
    this.cancel();
  }
  // 취소
  private cancel() {
    window.close();
  }

  private mounted() {
    this.reviewNos = JSON.parse(sessionStorage.getItem('reviewNos'));
    addClass(document.body, 'popup_small');
    addClass(document.getElementById('content'), 'review_change');
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
    removeClass(document.getElementById('content'), 'review_change');
  }
}
